import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../utils/Translations';
import ReloadHelper from '../../utils/ReloadHelper';
import ActorStatus  from '../SimpleElements/ActorStatus';

class NavbarFavoritesDropdownItem extends React.Component {

	static pjaxLinkHandler(e) {
		if (e.currentTarget && e.currentTarget.href) {
			ReloadHelper.reloadWithPjax(e.currentTarget.href, e);
		}
	}

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<li className="dropdown-menu__item__table">
				<a href={this.props.item.link}
				   onClick={NavbarFavoritesDropdownItem.pjaxLinkHandler}
				   className="dropdown-menu__item"
				>
					<span className="dropdown-menu__item__cell">
						<ActorStatus
							isActorOnline={this.props.item.isOnline}
							isActorMobileVideoCall={this.props.item.isOnlineMobileVideocall}
							previewPictureUrl={this.props.item.pictureUrl}
							size="md"
						/>
					</span>
					<span className="dropdown-menu__item__cell -vertical-middle">
						<span className="actor-name -navbar -extended">{this.props.item.name}</span>
						<span className="message-subject -font-small -text-ellipsis">{this.props.item.isOnline ? <span className="h-color-success"
						                                                                                               dangerouslySetInnerHTML={{__html: Translations.get('Online')}}
						/> : Translations.get('Offline')}</span>
					</span>
				</a>
			</li>
		);
	}
}

NavbarFavoritesDropdownItem.propTypes = {
	item: PropTypes.shape({
		pictureUrl:              PropTypes.string,
		link:                    PropTypes.string,
		isOnline:                PropTypes.bool,
		isOnlineMobileVideocall: PropTypes.bool,
		name:                    PropTypes.string,
	}),
};

export default NavbarFavoritesDropdownItem;
